import React from "react";

import RoomHeader from "../RoomHeader";
import CapacityItem from "./CapacityItem";
import AccessabiltyNavigation from "./AccessibiltyNavigation";
import Loginmask from "./../../../misc/login/Loginmask";

import { FaInfoCircle } from "react-icons/fa";
import { FaChair } from "react-icons/fa";
import { FaArrowsAlt } from "react-icons/fa";
import { FaWindowClose } from "react-icons/fa";

import { FaAccessibleIcon } from "react-icons/fa";

import { FaUniversalAccess } from "react-icons/fa";

import "./CapacityAccessabilityStyle.css";

const CapacityAccessability = ({ selectedRoom, loggedIn, loginSetter }) => {
  const flexBestuhlung = "Tische und Stühle sind verschiebbar";
  const noFlexBestuhlung = "Tische und Stühle sind fest montiert";

  const loginComponent = () => {
    return (
      <div className="swiper-slide-section" style={{ margin: "48px auto" }}>
        <Loginmask loginSetter={loginSetter} rootId={0} />
      </div>
    );
  };

  return (
    <div>
      <RoomHeader
        title="Raumkapazität &amp; Barrierefreiheit"
        subtitle={selectedRoom.hoersaal}
        icon={<FaInfoCircle className="section-indocator-icon" />}
      />

      <div className="swiper-slide-section capacity-container">
        <h3>Kapazität</h3>

        {selectedRoom.plaetze ? (
          <CapacityItem
            icon={<FaChair />}
            label={selectedRoom.plaetze + " Sitzplätze"}
          />
        ) : (
          <></>
        )}

        {selectedRoom.sitzreihen ? (
          <CapacityItem
            icon={<FaUniversalAccess />}
            label={selectedRoom.sitzreihen + " Sitzreihen"}
          />
        ) : (
          <></>
        )}

        {selectedRoom.sitzeproreihe ? (
          <CapacityItem
            icon={<FaUniversalAccess />}
            label={selectedRoom.sitzeproreihe + " Sitze pro Reihe"}
          />
        ) : (
          <></>
        )}

        {selectedRoom.flex_bestuhlung &&
        selectedRoom.flex_bestuhlung === "nein" ? (
          <CapacityItem icon={<FaWindowClose />} label={noFlexBestuhlung} />
        ) : (
          <CapacityItem icon={<FaArrowsAlt />} label={flexBestuhlung} />
        )}

        {selectedRoom.hoersaalkategorie ? (
          <CapacityItem
            icon={<FaUniversalAccess />}
            label={"Dieser Raum ist " + selectedRoom.hoersaalkategorie}
          />
        ) : (
          <></>
        )}
      </div>

      <div className="swiper-slide-section accessabillity-container">
        <h3>Barrierefreiheit</h3>
        <div className="accessability-item">
          <p className="accessability-pdf">
            <span className="accessability-icon">
              <FaAccessibleIcon />
            </span>

            <a
              style={{ color: "var(--color-neutral-white)" }}
              href={
                "https://www.uni-regensburg.de/assets/kontakt/dokumente/campus-barrierefrei.pdf"
              }
              target={"_blank"}
              rel="noreferrer"
            >
              Campusplan für Rollstuhlfahrer (PDF)
            </a>
          </p>

          {/* When user is logged in, the accessability information is displayed. Otherwise a login form is displayed. */}
          {loggedIn ? (
            <AccessabiltyNavigation
              roomID={selectedRoom.hoersaal}
              accessabilityEntry={selectedRoom.barrierefreiheit}
            />
          ) : (
            loginComponent()
          )}
        </div>
      </div>
    </div>
  );
};

export default CapacityAccessability;
